// What the browser can tell about the device, for «Сообщить об ошибке».
export async function collectClientInfo() {
  const nav = window.navigator || {}
  const info = {
    userAgent: nav.userAgent || '',
    platform: nav.platform || '',
    language: (nav.languages && nav.languages.join(', ')) || nav.language || '',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    localTime: new Date().toString(),
    screen: window.screen ? `${window.screen.width}x${window.screen.height}, ${window.screen.colorDepth} бит` : '',
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    pixelRatio: window.devicePixelRatio || '',
    touchPoints: nav.maxTouchPoints || 0,
    cpus: nav.hardwareConcurrency || '',
    memoryGb: nav.deviceMemory || '',
    connection: nav.connection ? [nav.connection.effectiveType, nav.connection.downlink && `${nav.connection.downlink} Мбит/с`].filter(Boolean).join(', ') : '',
    online: nav.onLine,
    cookies: nav.cookieEnabled,
    darkTheme: window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)').matches : '',
    referrer: document.referrer || '',
    historyLength: window.history ? window.history.length : ''
  }
  // Chromium browsers: the exact system and model
  if (nav.userAgentData) {
    info.uaData = { mobile: nav.userAgentData.mobile, platform: nav.userAgentData.platform,
      brands: (nav.userAgentData.brands || []).map(b => `${b.brand} ${b.version}`).join(', ') }
    try {
      const high = await nav.userAgentData.getHighEntropyValues(['platformVersion', 'model', 'architecture', 'fullVersionList'])
      Object.assign(info.uaData, { platformVersion: high.platformVersion, model: high.model, architecture: high.architecture,
        fullVersionList: (high.fullVersionList || []).map(b => `${b.brand} ${b.version}`).join(', ') })
    } catch (e) {
      // not given: the User-Agent stays
    }
  }
  return info
}
